import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

import MaterialTable from "@material-table/core";
import { ExportCsv } from "@material-table/exporters";

/*Import API helpers */
import { fetchGET, fetchPUT } from "../apiHelper";
import { sifrantARRS, sifrantKlasius, sifrantCerif, claniceV2, putClaniceV2 } from "../listOfApi";

/*React-Bootstrap components */
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";

/*React icons */
import { BsListOl } from "react-icons/bs";

import RoleGuard from "../auth/RoleGuard";
import { MODULES, ROLE_GROUPS } from "../auth/roles";
import AccessDenied from "./ui/AccessDenied";

const CodeList = () => {
  const [sifrantTitle, setSifrantTitle] = useState("ARIS");
  const [modalNaziv, setModalNaziv] = useState("");
  const [modalKontakt, setModalKontakt] = useState("");
  const [saveKontakt, setSaveKontakt] = useState("");
  const [sifrantList, setSifrantList] = useState([]);
  const [columnsList, setColumnsList] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const history = useNavigate();

  const columns = [
    {
      title: "Naziv",
      field: "naziv",
    },
  ];

  const columnsClanice = [
    {
      title: "Naziv",
      field: "naziv",
      width: null,
      cellStyle: { width: 100 },
    },
    {
      title: "Kontakt",
      field: "kontakt",
      width: null,
      cellStyle: { width: 800 },
    },
  ];

  useEffect(() => {
    fetchGET(sifrantARRS).then((sifrant) => {
      if (sifrant !== 0) {
        setSifrantList(sifrant);
        setColumnsList(columns);
      } else {
      }
    });
  }, []);

  const handleChangeARRS = () => {
    fetchGET(sifrantARRS).then((sifrant) => {
      if (sifrant !== 0) {
        setSifrantList(sifrant);
        setSifrantTitle("ARIS");
        setColumnsList(columns);
      }
    });
  };

  const handleChangeCerif = () => {
    fetchGET(sifrantCerif).then((sifrant) => {
      if (sifrant !== 0) {
        setSifrantList(sifrant);
        setSifrantTitle("CERIF");
        setColumnsList(columns);
      }
    });
  };

  const handleChangeKlasius = () => {
    fetchGET(sifrantKlasius).then((sifrant) => {
      if (sifrant !== 0) {
        setSifrantList(sifrant);
        setSifrantTitle("KLASIUS");
        setColumnsList(columns);
      }
    });
  };

  const handleChangeClanice = () => {
    fetchGET(claniceV2).then((sifrant) => {
      if (sifrant !== 0) {
        setSifrantList(sifrant);
        setSifrantTitle("ČLANICE");
        setColumnsList(columnsClanice);
      }
    });
  };

  const handleRowClick = (naziv, kontakt) => {
    setShowModal(true);
    setModalNaziv(naziv);
    setModalKontakt(kontakt);
    setSaveKontakt(kontakt);
  };

  const handleSaveKontakt = () => {
    fetchPUT(putClaniceV2, {"naziv": modalNaziv, "kontakt": saveKontakt}).then(
      (projekti) => {
        if (projekti === 1) {
          handleChangeClanice();
          setShowModal(false);
        } else {
          setShowModal(false);
        }
      }
    );
  };

  return (
    <RoleGuard
      moduleKey={MODULES.SIFRANTI}
      roles={ROLE_GROUPS.ALL}
      fallback={<AccessDenied />}
    >
      <Container fluid>
        <Row>
          <Col className="main-header font-weight-bold">
            <BsListOl className="me-2" />
            Šifranti
          </Col>
        </Row>
        <Row>
          <Col className="header-divider">
            <hr />
          </Col>
        </Row>
        <Row>
          <Col>
            <Button
              variant="outline-primary border-0"
              onClick={handleChangeARRS}
            >
              Šifranti ARIS
            </Button>{" "}
            {"|"}
            <Button
              variant="outline-primary border-0"
              onClick={handleChangeCerif}
            >
              Šifranti Cerif
            </Button>{" "}
            {"|"}
            <Button
              variant="outline-primary border-0"
              onClick={handleChangeKlasius}
            >
              Šifranti Klasius
            </Button>{" "}
            {"|"}
            <Button
              variant="outline-primary border-0"
              onClick={handleChangeClanice}
            >
              Šifrant članic
            </Button>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col>
            <h4>{sifrantTitle}</h4>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col>
            <MaterialTable
              title={""}
              columns={columnsList}
              data={sifrantList}
              localization={{
                toolbar: {
                  searchPlaceholder: "Iskalnik",
                  exportCSVName: "Izvozi podatke v CSV",
                },
                header: { actions: "" },
                body: {
                  emptyDataSourceMessage: "Ni zapisov za prikaz",
                },
              }}
              options={{
                headerStyle: { fontWeight: "bold" },
                paging: false,
                searchFieldAlignment: "left",
                actionsColumnIndex: -1,
                exportMenu: [
                  {
                    label: "Izvozi podatke v CSV",
                    exportFunc: (cols, datas) =>
                      ExportCsv(
                        cols,
                        datas,
                        sifrantTitle === "ARIS"
                          ? `sifrant_aris_${new Date().toLocaleDateString("sl-SI").replace(/\. /g, "-")}`
                          : sifrantTitle === "CERIF"
                            ? `sifrant_cerif_${new Date().toLocaleDateString("sl-SI").replace(/\. /g, "-")}`
                            : sifrantTitle === "KLASIUS"
                              ? `sifrant_klasius_${new Date().toLocaleDateString("sl-SI").replace(/\. /g, "-")}`
                              : `sifrant_clanice_${new Date().toLocaleDateString("sl-SI").replace(/\. /g, "-")}`,
                      ),
                  },
                ],
              }}
              actions={[
                (rowData) => (
                  sifrantTitle === "ČLANICE" ? {
                    icon: "edit",
                    tooltip: "Uredi " + rowData.naziv,
                    onClick: (event, rowData) => {
                      handleRowClick(rowData.naziv, rowData.kontakt);
                    },
                  } :
                  {}
                )
              ]}
            />
          </Col>
        </Row>
        <Modal
          show={showModal}
          onHide={() => {
            setShowModal(false);
          }}
          centered
        >
          <Modal.Body>
            <Row>
              <Col style={{fontWeight: "600", margin: "10px 10px 30px"}}>Sprememba kontakta za {modalNaziv}</Col>
            </Row>
            <Form.Control
              name="nazivSlo"
              type="text"
              required
              defaultValue={modalKontakt}
              onChange={e => {
                setSaveKontakt(e.target.value);
              }}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="btn btn-danger"
              variant="secondary"
              onClick={() => {
                handleSaveKontakt();
              }}
            >
              Shrani
            </Button>
            <Button
              variant="primary"
              onClick={() => {
                setShowModal(false);
              }}
            >
              Prekliči
            </Button>
          </Modal.Footer>
        </Modal>
      </Container>
    </RoleGuard>
  );
};

export default CodeList;
